import { ContentPage, Prose, Section } from '@/components/content-page'

export default function PrivacyPage() {
  return (
    <ContentPage
      eyebrow="// privacy"
      title="Privacy policy"
      description="The short version: we do not sell your information, and we do not share it with anyone. Ever."
    >
      <Prose>
        <Section title="The short version">
          <p>
            NewChirp does not sell personal information. NewChirp does not share personal
            information with third parties, advertisers, data brokers, or anyone else. We do not run
            third-party trackers or advertising on this site. The only people who can see your
            account information are you and the people who operate this site — and even we can only
            see it when it is needed to run the service.
          </p>
        </Section>

        <Section title="What we collect">
          <p>
            <span className="font-medium text-foreground">If you are just visiting:</span> we issue
            an anonymous, randomly generated visitor ID stored in a cookie, along with a hashed
            device fingerprint and a hashed IP address, so we can count unique visitors without
            letting refresh spam inflate the number. We also keep aggregate counts of main-page
            views; these totals do not identify individual visitors. None of this can identify you
            personally.
          </p>
          <p>
            <span className="font-medium text-foreground">If you create an account:</span> we store
            your email address, a securely hashed password, a forum handle you choose, and any avatar
            you upload. We also keep a hashed copy of the one-time verification code we send you by
            email, and records of your forum topics and replies.
          </p>
        </Section>

        <Section title="How we use your information">
          <p>
            Everything we collect is used to operate the site: to create and secure your account, to
            verify your email address, to let you participate in the forums, to display your handle
            and avatar next to your posts, to keep the forums civil through our automated content
            filters, and to count unique visitors. We do not use your information for anything else.
          </p>
        </Section>

        <Section title="Forum reactions">
          <p>
            Your handle may be shown to other members when you add a positive reaction such as a
            Like, Helpful, QSL, or Worked it! You can turn that attribution off from your account
            page. Dislike attribution is never shown publicly; it is available only to site
            moderators for abuse investigations.
          </p>
        </Section>

        <Section title="What we share">
          <p>
            Nothing. We do not sell your information, we do not rent it, and we do not share it with
            advertisers, analytics companies, data brokers, or any other third party. We do not sell
            or share data with anyone — period.
          </p>
        </Section>

        <Section title="Cookies">
          <p>
            We use two cookies. One is an anonymous visitor ID that lets us tell unique visitors
            apart. The other is a secure session cookie that keeps you logged in to your account.
            Both are essential to how the site works, and neither is used for advertising or
            tracking across other websites.
          </p>
        </Section>

        <Section title="Data security">
          <p>
            Passwords are never stored in plain text — they are hashed with scrypt before they touch
            the database. Verification codes are stored hashed, not plaintext. Session tokens and
            visitor IDs are stored hashed as well. The site is served over HTTPS, and we apply
            standard protections like rate limiting and content filtering to keep the service safe.
          </p>
        </Section>

        <Section title="Data retention">
          <p>
            Account data stays in our database for as long as your account exists. Anonymous visitor
            records are kept to maintain an accurate unique-visitor count. If you ask us to delete
            your account, we will remove your account, profile, and personal posts.
          </p>
        </Section>

        <Section title="Your choices">
          <p>
            You can change your forum handle and avatar and control whether your handle appears in
            positive reaction lists from your account page. You can log out at any time. To have
            your account and data deleted, contact us using the address below and we will take care
            of it.
          </p>
        </Section>

        <Section title="Children">
          <p>
            NewChirp is not directed at children under 13, and we do not knowingly collect
            information from children under 13. If you believe a child has provided us with personal
            information, contact us and we will delete it.
          </p>
        </Section>

        <Section title="Changes to this policy">
          <p>
            If we ever change this policy, we will update this page and the effective date below. Any
            change that would involve sharing or selling data would require a clear notice on the
            site — but we have no plans to ever do that.
          </p>
        </Section>

        <Section title="Contact">
          <p>
            Questions about this policy? Email{' '}
            <a
              href="mailto:rick@newchirp.net"
              className="text-primary underline underline-offset-4"
            >
              rick@newchirp.net
            </a>
            . Effective date: August 23, 2026.
          </p>
        </Section>
      </Prose>
    </ContentPage>
  )
}
